module.exports = __webpack_public_path__ + "7a14121a0cc7980e382e898e61f47d21.pdf";